import { UtilLayout } from "./layout";

export default function ErrorPage() {
  return <UtilLayout>Sorry, there was a problem.</UtilLayout>;
}
